// import React from "react";
// import { Container, Row, Col, Badge, Button } from "react-bootstrap";
// import { motion, AnimatePresence } from "framer-motion";
// import techax from "../assets/img/techax.png";
// import gssoc from "../assets/img/gssoc.jpeg";
// import iic from "../assets/img/iic.png";

// export const ExperienceSection = () => {
//   const experiences = [
//     {
//       companyName: "Techax Labs",
//       designation: "Web Developer Intern",
//       duration: "May 2024 – July 2024",
//       techStacks: ["Nest.js", "Next.js", "PostgreSQL", "TypeORM", "Swagger"],
//       description:
//         "Created the backend services for an e-commerce SaaS platform using Nest.js and designed the Admin Dashboard using Next.js. Merchants can create different stores on this platform to sell their products, customers can avail Promocodes, and Store Admin can manage the store and its revenue.",
//       //liveLink: "#",
//       //codeLink: "#",
//       image: techax,
//     },
//     {
//       companyName: "GirlScript Summer of Code",
//       designation: "Project Admin",
//       duration: "May 2024 – August 2024",
//       techStacks: ["GitHub", "MERN"],
//       description:
//         "Open sourced my edtech website. Guided contributors on version control, open-source contributions, reviewed and merged pull requests to ensure high-quality contributions",
//       //   liveLink: "#",
//       //   codeLink: "#",
//       image: gssoc,
//     },
//     {
//       companyName: "Institution’s Innovation Council (IIC-IEM)",
//       designation: "Project Intern",
//       duration: "April 2022 – June 2022",
//       techStacks: ["Solar Technology", "LDR"],
//       description:
//         "Contributed to the Problem Statement of the Department of Science and Technology (DoST), Ministry of Science and Technology. Introduced a solution for Solar panels with a solar tracking device without power consumption.",
//       //   liveLink: "#",
//       //   codeLink: "#",
//       image: iic,
//     },
//   ];

//   return (
//     <section className="experience-section" id="experience">
//       <Container>
//         <h2 className="section-title text-center mb-5">Experience</h2>
//         {experiences.map((exp, index) => (
//           <Row key={index} className="mb-5 align-items-center">
//             {/* Left Side */}
//             <Col md={6} className="text-center mb-4 mb-md-0">
//               <AnimatePresence>
//                 <motion.img
//                   src={exp.image}
//                   alt={`${exp.companyName} Project`}
//                   className="img-fluid"
//                   style={{
//                     width: "50%",
//                     height: "auto",
//                     borderRadius: "100px",
//                     boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//                     cursor: "pointer",
//                   }}
//                   initial={{ opacity: 0, x: -50 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   exit={{ opacity: 0, x: -50 }}
//                   transition={{ duration: 0.5, delay: index * 0.2 }}
//                   whileHover={{
//                     scale: 1.08,
//                     boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)",
//                   }}
//                 />
//               </AnimatePresence>
//             </Col>

//             {/* Right Side */}
//             <Col md={6}>
//               <motion.div
//                 initial={{ opacity: 0, x: 50 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.2 }}
//               >
//                 <h3 className="designation">{exp.designation}</h3>
//                 <h3 className="company-name">{exp.companyName}</h3>
//                 <p className="duration">{exp.duration}</p>
//                 <div className="tech-stack mb-3">
//                   {exp.techStacks.map((tech, techIndex) => (
//                     <Badge
//                       key={techIndex}
//                       className="me-2 mb-2"
//                       bg="light"
//                       text="dark"
//                       style={{
//                         transition:
//                           "transform 0.3s ease, background-color 0.3s ease",
//                         cursor: "pointer",
//                       }}
//                       onMouseEnter={(e) =>
//                         (e.target.style.transform = "scale(1.1)")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.target.style.transform = "scale(1)")
//                       }
//                     >
//                       {tech}
//                     </Badge>
//                   ))}
//                 </div>
//                 <p className="description">{exp.description}</p>
//                 {/* <Button
//                   variant="primary"
//                   className="me-2"
//                   href={exp.liveLink}
//                   target="_blank"
//                 >
//                   Live Link
//                 </Button>
//                 <Button
//                   variant="outline-primary"
//                   href={exp.codeLink}
//                   target="_blank"
//                 >
//                   Code Link
//                 </Button> */}
//               </motion.div>
//             </Col>
//           </Row>
//         ))}
//       </Container>
//     </section>
//   );
// };

import React, { useState } from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import techax from "../assets/img/techax.png";
import gssoc from "../assets/img/gssoc.jpeg";
import iic from "../assets/img/iic.png";

export const ExperienceSection = () => {
  const [selectedExperience, setSelectedExperience] = useState(0);

  const experiences = [
    {
      companyName: "Techax Labs",
      designation: "Web Developer Intern",
      duration: "May 2024 – July 2024",
      site: "Remote",
      techStacks: ["Nest.js", "Next.js", "PostgreSQL", "TypeORM", "Swagger"],
      description:
        "Created the backend services for an e-commerce SaaS platform using Nest.js and designed the Admin Dashboard using Next.js. Merchants can create different stores on this platform to sell their products, customers can avail Promocodes, and Store Admin can manage the store and its revenue.",
      image: techax,
    },
    {
      companyName: "GirlScript Summer of Code",
      designation: "Project Admin",
      duration: "May 2024 – August 2024",
      site: "Remote",
      techStacks: ["GitHub", "MERN"],
      description:
        "Open sourced my edtech website. Guided contributors on version control, open-source contributions, reviewed and merged pull requests to ensure high-quality contributions",
      image: gssoc,
    },
    {
      companyName:
        "Innovation and Entrepreneurship Development Centre, Kolkata",
      designation: "Project Intern",
      duration: "April 2022 – June 2022",
      site: "Onsite",
      techStacks: ["Solar Technology", "LDR"],
      description:
        "Contributed to the Problem Statement of the Department of Science and Technology (DoST), Ministry of Science and Technology. Introduced a solution for Solar panels with a solar tracking device without power consumption.",
      image: iic,
    },
  ];

  return (
    <section className="experience-section" id="experience">
      <Container>
        <h2 className="section-title text-center mb-5">Work Experience</h2>
        <Row>
          {/* Sidebar */}
          <Col md={5}>
            <div className="experience-sidebar">
              {experiences.map((exp, index) => (
                <div
                  key={index}
                  className={`sidebar-item ${
                    selectedExperience === index ? "active" : ""
                  }`}
                  onClick={() => setSelectedExperience(index)}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    marginBottom: "10px",
                    background: selectedExperience === index ? "#f0f0f0" : "",
                    color: selectedExperience === index ? "#020617" : "",
                    fontSize: "1.5rem",
                    borderRadius: "5px",
                    transition: "background 0.3s ease",
                  }}
                >
                  <img
                    src={exp.image}
                    alt={exp.companyName}
                    style={{ width: "40px", marginRight: "10px" }}
                  />
                  <span>
                    {exp.companyName ===
                    "Innovation and Entrepreneurship Development Centre, Kolkata"
                      ? "IEDC"
                      : exp.companyName}
                  </span>
                </div>
              ))}
            </div>
          </Col>

          {/* Experience Details */}
          <Col md={7}>
            <AnimatePresence>
              <motion.div
                key={selectedExperience}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <h3 className="designation">
                  {experiences[selectedExperience].designation}
                </h3>
                <h5 className="company-name">
                  {experiences[selectedExperience].site}
                </h5>
                <p className="duration">
                  {experiences[selectedExperience].duration}
                </p>
                <div className="tech-stack mb-3">
                  {experiences[selectedExperience].techStacks.map(
                    (tech, techIndex) => (
                      <Badge
                        key={techIndex}
                        className="me-2 mb-2"
                        bg="light"
                        text="dark"
                        style={{ transition: "transform 0.3s ease" }}
                      >
                        {tech}
                      </Badge>
                    )
                  )}
                </div>
                <p className="description">
                  {experiences[selectedExperience].description}
                </p>
              </motion.div>
            </AnimatePresence>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
